module.exports = __webpack_public_path__ + "static/q8_o-282678ce0840007eea5426546c902bbe.png";